'use client';

import { useLocale } from 'next-intl';
import { useSwitchLocale } from '@/hooks/use-switch-locale';
import Globe from '@/app/components/icons/Globe';

export default function LanguageSwitch() {
  const locale = useLocale();
  const switchLocale = useSwitchLocale();

  return (
    <button
      onClick={switchLocale}
      className={`absolute top-[56px] flex cursor-pointer flex-col ${
        locale === 'en' ? 'right-[56px]' : 'left-[56px]'
      } h-10 items-center justify-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-sm`}
    >
      <p className="flex items-center gap-2">
        {locale === 'en' ? <span className="mb-2">عربي</span> : 'English'}
        <Globe className="fill-current text-gray-500" />
      </p>
    </button>
  );
}
